import moment from "moment"

export default {
  "loginForm": {
    "username": "No Handphone atau Email",
    "password": "Kata Sandi",

    "usernamePlaceholder": "No HP atau Alamat Email",
    "passwordPlaceholder": "Kata Sandi",

    "phoneExample": "Contoh: 0896123465659"
  },

  "passwordResetForm": {
    "email": "Email",

    "emailPlaceholder": "Masukkan email anda"
  },

  "farmForm": {
    "name": "Nama Tambak",
    "area":"Luas (m²)",
    "countryId": "Negara",
    "regionId": "Kota/Kabupaten",
    "currencyId": "Mata Uang",
    "timezone": "Zona Waktu",
    "farmTooltip": "Catatkan nama tambak Anda di sini",
    "farmTooltip2": "Catatkan alamat tambak Anda di sini",
    "farmTooltip3": "Catatkan data tambahan tambak Anda di sini",
    "provinceId": "Provinsi",
    "regencyId": "Kota/Kabupaten",
    "districtId": "Kecamatan",
    "villageId": "Kelurahan",
    "address": "Alamat",

    "namePlaceholder": "Nama Tambak",
    "areaPlaceholder": "-",
    "countryIdPlaceholder": "Pilih Negara",
    "provinceIdPlaceholder": "Pilih Provinsi",
    "regencyIdPlaceholder": "Pilih Kota/Kabupaten",
    "districtIdPlaceholder": "Pilih Kecamatan",
    "villageIdPlaceholder": "Pilih Kelurahan",
    "addressPlaceholder": "Nama blok, nama jalan, keterangan lainnya",
    "regionIdPlaceholder": "Pilih Kota/Kabupaten",
    "currencyIdPlaceholder": "Pilih Mata Uang",
    "timezonePlaceholder": "Pilih Zona Waktu",

    "deleteSubtitle": "Data siklus, kolam, dan tambak akan terhapus dan tidak bisa diakses kembali.",
    "createFarm": "Buat tambak"
  },

  "pondForm": {
    "farmId": "Tambak",
    "title": "Buat Kolam untuk tambak",
    "totalPonds": "Jumlah Kolam",
    "namePrefix": "Nama Awalan Kolam",
    "name": "Nama Kolam",
    "type": "Tipe Kolam",
    "length": "Panjang Kolam (m)",
    "width": "Lebar Kolam (m)",
    "area": "Luas Kolam (m²)",
    "deep": "Kedalaman (m)",
    "diameter": "Diameter Kolam (m)",

    "farmIdPlaceholder": "-",
    "totalPondsPlaceholder": " ",
    "namePrefixPlaceholder": " ",
    "namePlaceholder": " ",
    "typePlaceholder": " ",
    "lengthPlaceholder": " ",
    "widthPlaceholder": " ",
    "areaPlaceholder": " ",
    "deepPlaceholder": " ",

    "namePrefixHelper": "Penomoran akan otomatis mengikuti jumlah kolam",

    "totalPondsMaxMessage": "Maksimal kolam yang dapat dibuat dalam satu waktu adalah %{max} kolam.",

    "pond": "Kolam",
    "formTitle": "Daftar Kolam",
    "formSubtitle": "Ubah luas kolam sesuai aktual agar perhitungan estimasi Jala lebih sesuai."
  },

  "cycleForm": {
    "id": "Siklus",
    "farmId": "Tambak",
    "pondId": "Kolam",
    "totalSeed": "Total Tebar (ekor)",
    "totalSeedType": "Tipe Total Tebar",
    "startedAt": "Tanggal Tebar",
    "finishedAt": "Tanggal Selesai",
    "initialAge": "Umur Awal (hari)",
    "preparationDay": "Lama Persiapan (hari)",
    "hatcheryId": "Hatchery",
    "speciesId": "Spesies",
    "broodStockProductId": "Broodstock",
    "feedingTrayCount": "Jumlah Anco",
    "limitWeightPerArea": "Batas Biomasa per Luasan (kg/m²)",
    "targetCultivationDay": "Target Lama Budidaya (hari)",
    "targetSize": "Target Size",
    "targetSurvivalRate": "Target SR (%)",
    "area": "Luas (m²)",
    "deep": "Kedalaman (m)",
    "survivalRatePredictionMethod": "Metode Prediksi SR",
    "remark": "Catatan (Opsional)",
    "minimumFr": "Tabel FR belum lengkap. Lengkapi tabel sampai DoC 60 di sini.",
    "warning": "Peringatan! mengganti tanggal tebar akan mengubah umur udang (DoC) serta perhitungan estimasi",
    "cycleTooltip": "Catatkan data siklus di sini",

    "idPlaceholder": "Pilih Siklus",
    "farmIdPlaceholder": "Pilih Tambak",
    "pondIdPlaceholder": "Pilih Kolam",
    "totalSeedPlaceholder": "Total tebar",
    "totalSeedTypePlaceholder": "Pilih Tipe Total Tebar",
    "startedAtPlaceholder": "Tanggal Tebar",
    "finishedAtPlaceholder": "Tanggal Selesai",
    "initialAgePlaceholder": "Opsional",
    "hatcheryIdPlaceholder": "Pilih Hatchery",
    "speciesIdPlaceholder": "Pilih Spesies",
    "broodStockProductIdPlaceholder": "Pilih Broodstock",
    "preparationDayPlaceholder": "Opsional",
    "feedingTrayCountPlaceholder": "Pilih Jumlah Anco",
    "limitWeightPerAreaPlaceholder": " ",
    "targetCultivationDayPlaceholder": " ",
    "targetSizePlaceholder": " ",
    "targetSurvivalRatePlaceholder": " ",
    "areaPlaceholder": " ",
    "deepPlaceholder": " ",
    "survivalRatePredictionMethodPlaceholder": "Pilih Metode Prediksi SR",
    "remarkPlaceholder": "Catatan",

    "initialAgeHelper": "Umur benur saat tebar",
    "targetSizeHelper": "DoC 100",

    "cycleClose": "Tutup Siklus",
    "targetAndCycles": "Target dan informasi siklus",
    "targetSubtitle": "Tentukan target budidaya Anda agar perhitungan estimasi Jala lebih sesuai.",
    "nextPond": "Kolam Selanjutnya",

    "net": "Netto",
    "gross": "Bruto",
    "actual": "Aktual",
    "netNote": "Jumlah benur yang diorder",
    "grossNote": "Sesuai kiriman hatchery",
    "actualNote": "Sesuai hitungan",

    "fr": "Rasio Pakan (FR)",
    "fixed": "Fix",
    "ai": "Berdasarkan Kualitas Air",
    "customFr": "Tabel FR Sendiri",
    "stpFr": "Tabel FR STP",
    "adg": "ADG",

    "cycle": "Siklus",
    "hatchery": "Hatchery",
    "hatcheryPlaceholder": "Pilih...",
    "species": "Species",
    "speciesPlaceholder": "Pilih...",
    "createCycle": "Buat siklus",
    "updateCycle": "Simpan"
  },

  "farmShrimpPriceForm": {
    "farmId": "Tambak",
    "shrimpPriceId": "Pilih Lokasi dan Harga",
    "shrimpPriceIdPrivate": "Pilih Referensi Lokasi dan Harga (opsional)",
    "shrimpPriceSubtitle": "Anda bisa memilih referensi lokasi harga atau membuat harga pribadi sendiri",

    "farmIdPlaceholder": "Pilih Tambak",
    "shrimpPriceIdPlaceholder": "Pilih Lokasi dan Harga",
    "shrimpPriceIdPrivatePlaceholder": "Pilih Referensi",

    "title": "Hubungkan estimasi biomassa dengan harga udang",
    "subtitle": "Jala akan menghitung nilai jual udang Anda berdasarkan estimasi biomassa dengan harga udang yang dipilih.",
    "helperText": "*Harga size 100 ekor/kg dari tanggal tebar terakhir: %{date}",
    "privateHelperText": "*Harga udang pribadi terakhir diubah oleh: %{user} pada : %{date}",

    "source": "Sumber nilai jual",
    "newest": "Harga Udang terbaru",
    "private": "Harga Udang Pribadi",
    "createNew": "Buat Baru",

    "privateFormTitle": "Buat Harga Udang Pribadi",
    "location": "Lokasi Tambak",
    "locationPlaceholder": "Isi nama lokasi",
    "currency": "Mata Uang",
    "delete": "Hapus Harga Pribadi?",
    "deleteDisclaimer": "Peringatan! Anda tidak akan bisa mengakses kembali harga yang telah dihapus",
    "info": "Harga udang pribadi yang tersimpan tidak akan tertampil di halaman harga udang publik",

    "createPrivateTitle": "Hubungkan estimasi biomassa dengan harga udang",
    "createPrivateSubtitle": "Jala akan menghitung nilai jual udang Anda berdasarkan estimasi biomassa dengan harga udang yang dipilih.",
    "size100Validation": "size 100 wajib untuk diisi",

    "deleteModalTitle": "Hapus harga udang pribadi",
    "deleteModalSubtitle": "Apakah anda yakin ingin menghapus data ini?",
    "emptyPrivatePriceTitle": "Harga udang pribadi belum tersedia",
    "emptyPrivatePriceSubtitle": "Anda dapat membuat list harga udang pribadi agar bisa disambungkan kedalam estimasi nilai jual",
    "dropdownPrivateTitle": "Pilih Harga Udang Pribadi",
    "sizeInput": "Harga dan Size",
    "createdBy": "Dibuat oleh: {{user}}",

    "privateShrimpPriceSaveTitle": "Simpan Harga Pribadi?",
    "privateShrimpPriceSaveSubtitle": "Apakah kamu yakin ingin menyimpan harga udang pribadi?",
    "newestShrimpPriceSaveTitle": "Simpan Harga Terbaru?",
    "newestShrimpPriceSaveSubtitle": "Apakah kamu yakin ingin menyimpan harga udang terbaru?",
  },

  "waterQualityMultiMeasurementForm": {
    "farmId": "Tambak",
    "batchId": "Batch",
    "pondId": "Kolam",
    "cycleId": "Kolam",
    "measuredDate": "Tanggal Pengukuran",
    "measuredTime": "Jam Pengukuran",
    "temperature": "Suhu (°C)",
    "ph": "pH",
    "salinity": "Salinitas (ppt)",
    "do": "DO (mg/L)",
    "transparency": "Kecerahan (cm)",
    "waterLevel": "Ketinggian Air (cm)",
    "doPercent": "Persen DO (%)",
    "turbidity": "Turbiditas (NTU)",
    "ec": "Konduktivitas Listrik (µS)",
    "color": "Warna Air",
    "weather": "Cuaca",
    "measurementTooltip": "Catatkan data kualitas air di sini",
    "orp": "ORP (mV)",

    "farmIdPlaceholder": "Pilih Tambak",
    "batchIdPlaceholder": "Pilih Batch",
    "pondIdPlaceholder": "Pilih Kolam",
    "cycleIdPlaceholder": "Pilih Kolam",
    "measuredDatePlaceholder": "Tanggal Pengukuran",
    "measuredTimePlaceholder": "Jam Pengukuran",
    "temperaturePlaceholder": "-",
    "phPlaceholder": "-",
    "salinityPlaceholder": "-",
    "doPlaceholder": "-",
    "transparencyPlaceholder": "-",
    "waterLevelPlaceholder": "-",
    "doPercentPlaceholder": "-",
    "turbidityPlaceholder": "-",
    "ecPlaceholder": "-",
    "colorPlaceholder": "Pilih Warna Air",
    "weatherPlaceholder": "Pilih Cuaca",
    "orpPlaceholder": "-",

    "waterQualityMultiMeasurement": "Kualitas Air Fisik",
    "otherParameters": "Parameter lainnya",
  },
  "feedForm": {
    "farmId": "Tambak",
    "cycleId": "Kolam",
    "loggedDate": "Tanggal",
    "loggedTime": "Jam",
    "stockId": "Stok",
    "quantity": "Jumlah Pakan (kg)",
    "fasting": "Puasa",
    "remark": "Catatan (Opsional)",
    "feedTooltip": "Catatkan data Pakan yang anda berikan di sini",

    "farmIdPlaceholder":"Pilih Tambak",
    "cycleIdPlaceholder": "Pilih Kolam",
    "loggedDatePlaceholder": "Tanggal Pakan",
    "loggedTimePlaceholder": "Jam Pakan",
    "stockIdPlaceholder": "Pilih Stok",
    "quantityPlaceholder": " ",
    "remarkPlaceholder": "Catatan",

    "feeding": "Pemberian pakan"
  },
  "feedingTrayControlForm": {
    "farmId": "Tambak",
    "cycleId": "Kolam",
    "loggedDate": "Tanggal",
    "loggedTime": "Jam Cek Anco",
    "feedLoggedAt": "Jam Pemberian Pakan",
    "remark": "Catatan (Opsional)",
    "trayTooltip": "Catatkan data pengecekan anco di sini",
    "remainFeed": "Pilih hasil sisa pakan di anco",

    "feedingTray": "Anco %{number}",

    "farmIdPlaceholder":"Pilih Tambak",
    "cycleIdPlaceholder": "Pilih Kolam",
    "loggedDatePlaceholder": "Pilih Tanggal",
    "loggedTimePlaceholder": "Pilih Jam",
    "feedLoggedAtPlaceholder": "Pilih Jam Pemberian Pakan",
    "remarkPlaceholder": "Catatan",
    "feedingTrayControlRemark": "*Sisa pakan di Anco:",

    "feedingTrayControl": "Anco"
  },
  "samplingForm": {
    "farmId": "Tambak",
    "cycleId": "Kolam",
    "sampledAt": "Tanggal",
    "averageWeight": "MBW (g)",
    "files": "Foto",
    "remark": "Catatan (Opsional)",
    "sampleTooltip": "Catatkan data hasil sampling di sini",

    "farmIdPlaceholder":"Pilih Tambak",
    "cycleIdPlaceholder": "Pilih Kolam",
    "sampledAtPlaceholder": "Tanggal Sampling",
    "averageWeightPlaceholder": " ",
    "filesPlaceholder": "Foto",
    "remarkPlaceholder": "Catatan",

    "sampling": "Sampling"
  },
  "treatmentForm": {
    "farmId": "Tambak",
    "pondId": "Kolam",
    "cycleId": "Kolam",
    "stockId": "Stok",
    "name": "Perlakuan",
    "treatedAt": "Tanggal",
    "quantity": "Jumlah",
    "remark": "Catatan (Opsional)",
    "treatmentTooltip": "Catatkan data perlakuan kolam pada tiap kolam",

    "farmIdPlaceholder":"Pilih Tambak",
    "pondIdPlaceholder": "Pilih Kolam",
    "cycleIdPlaceholder": "Pilih Kolam",
    "stockIdPlaceholder": "Pilih Stok",
    "namePlaceholder": "Perlakuan",
    "treatedAtPlaceholder": "Pilih Tanggal",
    "quantityPlaceholder": " ",
    "remarkPlaceholder": "Catatan",

    "treatment": "Perlakuan",

    "recordType": "Tipe catatan",
    "radioBasic": "Catatan tertulis",
    "radioPro": "Penggunaan produk",
  },
  "harvestForm": {
    "farmId": "Tambak",
    "cycleId": "Kolam",
    "harvestedAt": "Tanggal",
    "status": "Jenis Panen",
    "weight": "Total Berat (kg)",
    "size": "Size (ekor/kg)",
    "price": "Harga per kg",
    "sellingPrice": "Total Harga",
    "buyer": "Pembeli (Opsional)",
    "remark": "Catatan (Opsional)",
    "harvestTooltip": "Catatkan data Panen di sini. Anda dapat memilih antara status jenis panen parsial, total atau gagal",

    "farmIdPlaceholder":"Pilih Tambak",
    "cycleIdPlaceholder": "Pilih Kolam",
    "harvestedAtPlaceholder": "Tanggal Panen",
    "statusPlaceholder": "Pilih Jenis Panen",
    "weightPlaceholder": " ",
    "sizePlaceholder": " ",
    "pricePlaceholder": " ",
    "buyerPlaceholder": "Pembeli",
    "remarkPlaceholder": "Catatan",

    "full": "Total",
    "partial": "Parsial",
    "failed": "Gagal",
    "harvest": "Panen"
  },
  "mortalityForm": {
    "farmId": "Tambak",
    "cycleId": "Kolam",
    "recordedAt": "Tanggal",
    "totalWeight": "Total Berat (kg)",
    "size": "Size (ekor/kg)",
    "multiplier": "Pengali",
    "quantityFinal": "Total Kematian (ekor)",
    "multiplierInfo": "Prediksi potensi kematian udang yang tidak teridentifikasi.",
    "files": "Foto",
    "remark": "Catatan (Opsional)",
    "mortalityTooltip": "Catatkan data kematian di sini",

    "farmIdPlaceholder": "Pilih Tambak",
    "cycleIdPlaceholder": "Pilih Kolam",
    "recordedAtPlaceholder": "Pilih Tanggal",
    "totalWeightPlaceholder": "0",
    "sizePlaceholder": "0",
    "multiplierPlaceholder": "Contoh: 1,5",
    "filesPlaceholder": "Foto",
    "remarkPlaceholder": "Catatan",
    "quantityPlaceholder": "0",

    "mortality": "Kematian",

    "averageWeight": "MBW (g)",
    "quantity": "Jumlah ekor (estimasi)",

    "basedOn": "Berdasarkan",
    "basedOnQuantity": "Jumlah (ekor)",
    "basedOnSize": "Size"
  },
  "chemicalMultiMeasurementForm": {
    "farmId": "Tambak",
    "batchId": "Batch",
    "pondId": "Kolam",
    "cycleId": "Kolam",
    "measuredDate": "Tanggal Pengukuran",
    "measuredTime": "Jam Pengukuran",
    "chemicalTooltip": "Catatkan data kimia di sini",

    "ammonia": "Amonia (NH3) (ppm)",
    "nitrat": "Nitrat (NO3) (ppm)",
    "nitrit": "Nitrit (NO2) (ppm)",
    "alkalinity": "Alkalinitas (Alkalinity) (ppm)",
    "hardness": "Kesadahan (Hardness) (ppm)",
    "calcium": "Kalsium (Ca) (ppm)",
    "magnesium": "Magnesium (Mg) (ppm)",
    "carbonat": "Karbonat (CO3) (ppm)",
    "bicarbonat": "Bikarbonat (HCO3) (ppm)",
    "tom": "Jumlah Bahan Organik (TOM) (ppm)",
    "orp": "Potensial Oksidasi-Reduksi (ORP) (mV)",
    "ammonium": "Amonium (NH4) (ppm)",
    "phosphate": "Fosfat (PO4) (ppm)",
    "totalAmmonia": "Total Ammonia (ppm)",
    "potassium": "Potassium (ppm)",

    "farmIdPlaceholder": "Pilih Tambak",
    "batchIdPlaceholder": "Pilih Batch",
    "pondIdPlaceholder": "Pilih Kolam",
    "cycleIdPlaceholder": "Pilih Kolam",
    "measuredDatePlaceholder": "Tanggal Pengukuran",
    "measuredTimePlaceholder": "Jam Pengukuran",

    "ammoniaPlaceholder": "-",
    "nitratPlaceholder": "-",
    "nitritPlaceholder": "-",
    "alkalinityPlaceholder": "-",
    "hardnessPlaceholder": "-",
    "calciumPlaceholder": "-",
    "magnesiumPlaceholder": "-",
    "carbonatPlaceholder": "-",
    "bicarbonatPlaceholder": "-",
    "tomPlaceholder": "-",
    "orpPlaceholder": "-",
    "ammoniumPlaceholder": "-",
    "phosphatePlaceholder": "-",
    "totalAmmoniaPlaceholder": "-",
    "potassiumPlaceholder": "-",

    "chemical": "Kimia"
  },
  "planktonMultiMeasurementForm": {
    "farmId": "Tambak",
    "batchId": "Batch",
    "pondId": "Kolam",
    "cycleId": "Kolam",
    "measuredDate": "Tanggal Pengukuran",
    "measuredTime": "Jam Pengukuran",
    "planktonTooltip": "Catat data plankton di sini",

    "totalPlankton": "Total Plankton (Total) (cell/ml)",
    "ga": "Green Algae (GA) (cell/ml)",
    "bga": "Blue Green Algae (BGA) (cell/ml)",
    "dino": "Dinoflagellata (DINO) (cell/ml)",
    "diatom": "Diatom (cell/ml)",
    "prozoo": "Protozoa (PRO) (cell/ml)",
    "floc": "Floc (ml)",
    "gba": "Golden Brown Algae (GBA) (cell/ml)",
    "euglenophyta": "Euglenophyta (cell/ml)",
    "zoo": "Zoo (ZOO) (cell/ml)",
    "haptyophyta": "Haptyophyta (cell/ml)",
    "gga": "Golden Green Algae (GGA) (cell/ml)",
    "yga": "Yellow Green Algae (YGA) (cell/ml)",

    "farmIdPlaceholder": "Pilih Tambak",
    "batchIdPlaceholder": "Pilih Batch",
    "pondIdPlaceholder": "Pilih Kolam",
    "cycleIdPlaceholder": "Pilih Kolam",
    "measuredDatePlaceholder": "Tanggal Pengukuran",
    "measuredTimePlaceholder": "Jam Pengukuran",

    "totalPlanktonPlaceholder": "-",
    "gaPlaceholder": "-",
    "bgaPlaceholder": "-",
    "dinoPlaceholder": "-",
    "diatomPlaceholder": "-",
    "prozooPlaceholder": "-",
    "flocPlaceholder": "-",
    "gbaPlaceholder": "-",
    "euglenophytaPlaceholder": "-",
    "zooPlaceholder": "-",
    "haptyophytaPlaceholder": "-",
    "ggaPlaceholder": "-",
    "ygaPlaceholder": "-",

    "plankton": "Plankton"
  },
  "microbiologyMultiMeasurementForm": {
    "farmId": "Tambak",
    "batchId": "Batch",
    "pondId": "Kolam",
    "cycleId": "Kolam",
    "measuredDate": "Tanggal Pengukuran",
    "measuredTime": "Jam Pengukuran",
    "microbiologyTooltip": "Catatkan data mikrobiologi di sini",

    "totalBacteria": "Total Bacteria (CFU/ml)",
    "totalVibrio": "Total Vibrio (CFU/ml)",
    "yellow": "Yellow Vibrio (CFU/ml)",
    "green": "Green Vibrio (CFU/ml)",
    "black": "Black (CFU/ml)",
    "luminance": "Luminance (CFU/ml)",

    "farmIdPlaceholder": "Pilih Tambak",
    "batchIdPlaceholder": "Pilih Batch",
    "pondIdPlaceholder": "Pilih Kolam",
    "cycleIdPlaceholder": "Pilih Kolam",
    "measuredDatePlaceholder": "Tanggal Pengukuran",
    "measuredTimePlaceholder": "Jam Pengukuran",

    "totalBacteriaPlaceholder": "-",
    "totalVibrioPlaceholder": "-",
    "yellowPlaceholder": "-",
    "greenPlaceholder": "-",
    "blackPlaceholder": "-",
    "luminancePlaceholder": "-",

    "microbiology": "Mikrobiologi"
  },
  "cycleDiseaseForm" : {
    "farmId": "Tambak",
    "cycleId": "Kolam",
    "loggedDate": "Tanggal",
    "diseaseId": "Nama Penyakit",
    "otherDisease": "Nama Penyakit Lainnya",
    "files": "Foto",
    "remark": "Catatan (Opsional)",
    "diseaseTooltip": "Catatkan data hasil uji penyakit di sini",
    "diseaseEvidence": "Unggah foto udang yang terinfeksi sebagai catatan tambahan",

    "farmIdPlaceholder": "Pilih Tambak",
    "cycleIdPlaceholder": "Pilih Kolam",
    "loggedDatePlaceholder": "Tanggal",
    "diseaseIdPlaceholder": "Pilih Penyakit",
    "otherDiseasePlaceholder": "Penyakit Lainnya",
    "filesPlaceholder": "Foto",
    "remarkPlaceholder": "Catatan",

    "cycleDisease": "Penyakit"
  },

  "simulationForm": {
    "name": "Nama Simulasi",
    "area": "Luas Kolam (m²)",
    "date": "Tanggal Tebar",
    "seed": "Jumlah Tebar",
    "periode": "Periode Panen",
    "biomass": "Biomassa Maks (kg/m²)",
    "survival": "Target Survival Rate (%)",
    "size": "Size di umur 100 hari (ekor/kg)",
    "feed": "Harga Pakan Per-kg",
    "shouldBeFilled": "Wajib diisi",
    "shouldBeGreaterThan": "Nilai harus lebih besar dari {{value}}",
    "shouldBeLessThan": "Nilai harus lebih kecil dari {{value}}",
    "age": "Isi umur",
    "percent": "Isi persentase",
    "namePlaceholder": `Simulasi ${moment().format('YYYY-MM-DD')}`,
    "areaPlaceholder": "1.000 m²",
    "datePlaceholder": "Pilih tanggal",
    "seedPlaceholder": "100.000 ekor",
    "periodePlaceholder": "120 hari",
    "biomassPlaceholder": "1.2 kg/m²",
    "survivalPlaceholder": "100%",
    "sizePlaceholder": "45",
    "feedPlaceholder": "Rp 15.000",
    "agePlaceholder": "Isi umur",
    "percentPlaceholder": "Isi persentase"
  },

  "autoFeederDailyFeedForm": {
    "title": "Tambah Data Pakan Asto",
    "subtitle": "Detail Pemberian Pakan",
    "start": "Mulai",
    "end": "Selesai",
    "quantity": "Pakan",
    "quantitycontinuous": "Total Pakan Sehari",
    "remark": "Catatan (opsional)",
    "disclaimer": "Data Pakan yang di tambahkan di Asto akan terhubung dengan data budidaya di JALA",

    "remarkPlaceholder": "#AutoFeeder",
    "ratio": "Rasio pembagian pakan"
  }
}
